import { render, staticRenderFns } from "./TreasuriesStatistics.vue?vue&type=template&id=a38bc2de&"
import script from "./TreasuriesStatistics.vue?vue&type=script&lang=js&"
export * from "./TreasuriesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports